import React, { useEffect } from 'react';
import { CloseIcon } from 'src/components/shared/elements/icons/CloseIcon';
import styles from './index.module.scss';

type Props = {
  title?: string;
  closeModal: () => void;
  fixedElement?: React.ReactNode;
  children?: React.ReactNode;
};

export const CommonModal: React.FC<Props> = ({ children, title, closeModal, fixedElement }) => {
  useEffect(() => {
    document.body.classList.add('no-scroll');

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <div className={styles.container} onClick={closeModal}>
      <div className={styles.closeIconContainer}>
        <div className={styles.closeIcon} onClick={closeModal}>
          <CloseIcon width={13} height={13} />
        </div>
      </div>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        {title ? <div className={styles.title}>{title}</div> : null}
        {children && <div className={styles.children}>{children}</div>}
        <div className={styles.fixedElement}>{fixedElement}</div>
      </div>
    </div>
  );
};
